import TextInput from "@/components/form/TextInput";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import React, { useState } from "react";
import RegisterForm from "./RegisterForm";
import { User } from "@/models/user.model";
import StaffInfoForm from "../../onboard-page/StaffInfoForm";
import { StaffInfo } from "@/models/staff-info.model";
import { EmploymentInfo } from "@/models/employment-info.model";
import EmploymentInfoForm from "../../onboard-page/EmploymentInfoForm";
import PaymentInfoForm from "../../onboard-page/PaymentInfoForm";
import Card from "@/components/Card";

function RegisterEmployeePage() {
  return (
    <div className="flex w-full flex-col h-[100vh] p-4">
      <Card styles="flex w-full flex-col p-5 h-full">
        <div className="flex flex-col gap-2 mb-6 p-6 self-center">
          <div className="font-bold text-2xl text-center">
            Register a New Account
          </div>
          <div className="text-gray-500 text-center">
            Fill in the account details.
          </div>
        </div>
        <div className="flex w-full">
          <RegisterForm />
        </div>
      </Card>
    </div>
  );
}

export default RegisterEmployeePage;
